import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CurrentUserService } from 'src/app/services/current-user.service';
import { ProductsService } from 'src/app/services/index-service';
import { arrayToPipeString } from 'src/app/shared/helper/custom-function';

@Component({
	selector: 'app-brand-filter',
	template: `
		<app-select-filter 
			[hasIcon] = "hasIcon"
			bindLabel = "name"
			bindValue = "id"
			placeholder = "Select Brand"
			label = "Brand"
			[clearable]="multiple"
			[multiple] = "multiple"
			[items] = "metadata.data"
			[(value)] = value
			(valueChange)="valueChange.emit(value)"
		>
		</app-select-filter>
    `,
})

export class AppBrandFilterComponent implements OnInit {
	@Input() multiple = false;
	@Input() forCurrentUserOnly = false;
	@Input() params: Object = null;
	@Input() value: any = null;
	@Output() valueChange = new EventEmitter();
	@Input() hasIcon = false;
	@Input() hasDefault = false;
	metadata = {
		data: [],
		limit: 100,
		total: 0,
		search: '',
	}
	constructor(private productService: ProductsService, private cUser: CurrentUserService) { }

	ngOnInit() {
		this.getBrands();
	}

	getBrands() {
		let mtd = this.metadata;
		if (!mtd.data.length || mtd.data.length < mtd.total) {
			const params = {
				brandIds: this.forCurrentUserOnly ? arrayToPipeString(this.cUser.brandIds) : '',
				limit: mtd.limit,
				offset: mtd.data.length,
				...this.params,
			};
			this.productService
				.brandFilter(params)
				.subscribe((res: any) => {
					const mappedData = (res.data || []).map(d => {
						return {
							id: d.id,
							name: d.displayName,
						}
					})
					mtd.data = [...mtd.data, ...mappedData];
					mtd.total = res.metadata.total;

					if (mtd.data.length && mtd.data.length < mtd.total) this.getBrands();
					else {
						if (!this.multiple) {
							mtd.data.unshift({
								id: '',
								name: 'All',
							});
							this.value = this.value || mtd.data[0].id;
						}

						if (this.multiple && this.hasDefault) {
							this.value = [mtd.data[0].id];
							this.valueChange.emit(this.value);
						}
					}
				});
		}

	}
}